<template>
  <v-row dense align="center" justify="end">
    <v-col cols="auto">
      <ActionNextWorkflow
        :attendance="attendance"
        :nextWorkflowStatus="nextWorkflowStatus"
        :startAttendance="startAttendance"
        v-slot:default="{ clickEvent, on, attrs }"
      >
        <v-btn
          small
          icon
          :attrs="attrs"
          v-on="on"
          @click="clickEvent"
          :disabled="!nextWorkflowStatus || attendanceEsigned"
        >
          <v-icon>eva-arrowhead-right-outline</v-icon>
        </v-btn>
      </ActionNextWorkflow>
    </v-col>

    <v-col cols="auto">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn small icon @click="openMedicalRecord" v-bind="attrs" v-on="on">
            <v-icon>ri-dossier-line</v-icon>
          </v-btn>
        </template>

        Abrir prontuário
      </v-tooltip>
    </v-col>

    <v-col cols="auto">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn small icon v-bind="attrs" v-on="on" @click="$router.push(`/pacientes/${attendance.patient.id}/atendimentos`)">
            <v-icon>
              ri-git-repository-line
            </v-icon>
          </v-btn>
        </template>

        Abrir Histórico do Paciente
      </v-tooltip>
    </v-col>

    <v-col cols="auto">
      <ActionNextWorkflow
        :attendance="attendance"
        :nextWorkflowStatus="extraWorkflowStatus"
        :startAttendance="startAttendance"
        v-slot:default="{ clickEvent, on, attrs }"
      >
        <v-btn
          small
          icon
          :attrs="attrs"
          v-on="on"
          @click="clickEvent"
          :disabled="lodash.isEmpty(extraWorkflowStatus)"
        >
          <v-icon>eva-more-vertical-outline</v-icon>
        </v-btn>
      </ActionNextWorkflow>
    </v-col>

    <v-col cols="auto">
      <ActionNextWorkflow
        :attendance="attendance"
        :nextWorkflowStatus="[endWorkflowStatus]"
        :startAttendance="startAttendance"
        v-slot:default="{ clickEvent, on, attrs }"
      >
        <v-btn
          small
          icon
          :attrs="attrs"
          v-on="on"
          @click="clickEvent"
          :disabled="!endWorkflowStatus"
        >
          <v-icon color="red">ri-stop-circle-line</v-icon>
        </v-btn>
      </ActionNextWorkflow>
    </v-col>
  </v-row>
</template>

<script>
import CHANGE_WORKFLOW_STATUS from "@/graphql/change_workflow_status.gql";

import ActionNextWorkflow from "@/components/queues/attendance/actions/next_workflow.vue";

export default {
  name: "Actions",
  components: {
    ActionNextWorkflow,
  },
  props: {
    permittedWorkflowStatuses: Array,
    attendance: Object,
    attendanceEsigned: Boolean,
    currentWorkflowStatus: Object,
    refreshQueue: {
      type: Function,
      default: () => {},
    },
    medicalRecordPath: {
      type: String,
      default: "pre-exame",
    },
  },
  data() {
    return {
      activePreExam: false,
    };
  },
  computed: {
    nextWorkflowStatuses() {
      return this.lodash.filter(this.permittedWorkflowStatuses, (e) => {
        return e.actionName !== "Finalizar atendimento";
      });
    },
    nextWorkflowStatus() {
      if (this.currentWorkflowStatus) {
        const nextStatuses = this.currentWorkflowStatus.nextStatuses;
        return this.lodash.intersectionBy(
          this.nextWorkflowStatuses,
          nextStatuses,
          "id"
        );
      }

      return this.lodash.filter(this.nextWorkflowStatuses, (e) => e.initial);
    },
    extraWorkflowStatus() {
      return this.nextWorkflowStatuses;
    },
    endWorkflowStatus() {
      return this.lodash.find(this.permittedWorkflowStatuses, {
        actionName: "Finalizar atendimento",
      });
    },
  },
  methods: {
    openMedicalRecord() {
      this.$router.push({
        path: `/prontuario/${this.attendance.id}/${this.medicalRecordPath}`,
        query: { redirectTo: this.$route.fullPath },
      });
    },
    startAttendance(workflow_status, attendancePlaceId) {
      //seguir o fluxo de execução: 0= Não, 1= Sim
      let vnExecute = 1;

      if (attendancePlaceId == null) {
        if (confirm("Você realmente deseja finalizar o atendimento?"))
          vnExecute = 1;
        else vnExecute = 0;
      }

      //se for para executar atualização da da situação do atendimento faça
      if (vnExecute === 1) {
        this.apolloMutate({
          mutation: CHANGE_WORKFLOW_STATUS,
          variables: {
            attendanceId: this.attendance.id,
            workflowStatusId: workflow_status.id,
            attendancePlaceId: attendancePlaceId,
          },
        })
          .then(() => {
            this.$store.dispatch("createNotification", {
              message: `Paciente ${workflow_status.name}`,
              type: "success",
            });

            this.refreshQueue();
          })
          .catch((error) => {
            const errorMessage = error.message.replace("GraphQL error: ", "");

            this.$store.dispatch("createNotification", {
              message: errorMessage,
              type: "error",
            });
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
